import React, { ReactElement } from 'react';
import { useSelector } from 'react-redux';
import { selectCurrentStepName } from '../../store/selectors/selectStepOrder';
import { stepMap } from '../../stepMap';

function RenderStep(): ReactElement {
  const currentStepName = useSelector(selectCurrentStepName);
  const CurrentStepComponent = stepMap[currentStepName];

  return <CurrentStepComponent />;
}

export { RenderStep };
